module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "foot"
  }, [_c('footer', {
    staticClass: "vux-1px-t"
  }, [_c('router-link', {
    attrs: {
      "tag": "div",
      "to": "/home"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-fangzi"
  }), _vm._v(" "), _c('span', [_vm._v("首页")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "div",
      "to": "/classify"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-tubiao3"
  }), _vm._v(" "), _c('span', [_vm._v("分类")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "div",
      "to": "/shoppCart"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-gouwuche"
  }, [(_vm.cartCountNum) ? _c('i', {
    staticClass: "tag"
  }, [_vm._v(_vm._s(_vm.cartCountNum))]) : _vm._e()]), _vm._v(" "), _c('span', [_vm._v("购物车")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "div",
      "to": "/userCenter"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-my"
  }), _vm._v(" "), _c('span', [_vm._v("我的")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76c48c62"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer/Footer.vue
// module id = 595
// module chunks = 0